// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".timeline__end-of-timeline{text-align:center;margin:10% 0 0;padding:50px 4% 4%}.timeline__end-of-timeline h3{margin-bottom:8px}.timeline__end-of-timeline p{margin:0 0 14px;padding:0 10px 10px}", ""]);
// Exports
module.exports = exports;
